import React from 'react';
import styles from '@/styles/components/profile/ProfileField.module.css';

export interface ProfileFieldProps {
  icon: string;
  iconAlt: string;
  value: string;
  actions: Array<{
    label: string;
    onClick: () => void;
    variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';
  }>;
  isMonospace?: boolean;
}

const ProfileField: React.FC<ProfileFieldProps> = ({
  icon,
  iconAlt,
  value,
  actions,
  isMonospace = false,
}) => {
  return (
    <div className={styles.field}>
      <img
        src={icon}
        alt={iconAlt}
        className={styles.leadIcon}
      />
      <div className={styles.textContainer}>
        <div className={`${styles.fieldText} ${isMonospace ? styles.monospace : ''}`}>
          {value}
        </div>
      </div>
      <div className={styles.rightContainer}>
        {actions.map((action, index) => (
          <button
            key={index}
            onClick={action.onClick}
            className={styles.actionButton}
            type="button"
          >
            {action.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProfileField;